import * as actions from './userListActionTypes';
import piction from '../utils/piction';
import { SESSION_EXPIRED_MESSAGE } from '../constants/sessionStateTypes';
import { sessionExpired } from './session';

export const getUsersRequest = requestPromise => ({
  type: actions.USER_LIST_REQUEST,
  requestPromise,
});

export const getUsersSuccess = res => ({
  type: actions.USER_LIST_SUCCESS,
  res,
});

export const getUsersFailure = error => ({
  type: actions.USER_LIST_FAILURE,
  error,
});

export const getUsers = isFullList =>
  function getUsersDispatch(dispatch) {
    const callArgs = {
      SORT: 'USERNAME',
      FULLNAME: 'TRUE',
      EXCLUDE_TITLE: 'PORTAL',
    };
    const promise = piction.request('Profile', callArgs)
      .then((res) => {
        if (res && res.a && res.a.p && _.isArray(res.a.p)) {
          dispatch(getUsersSuccess(res.a.p));
          return res.a.p;
          // const userList = res.map(user => user._);
          // return isFullList ? res : userList;
        } else if (res.message && res.message.includes(SESSION_EXPIRED_MESSAGE)) {
          dispatch(sessionExpired(res));
          return res;
        }
        dispatch(getUsersFailure(res));
        return res;
      })
      .catch((error) => {
        if (error.message && error.message.includes(SESSION_EXPIRED_MESSAGE)) {
          dispatch(sessionExpired(error));
        } else {
          dispatch(getUsersFailure(error));
        }
        return error;
      });

    dispatch(getUsersRequest(promise));
    return promise;
  };

export const getUsersDismiss = () => ({
  type: actions.USER_LIST_DISMISS,
});


export const retrieveDownloadRulesRequest = requestPromise => ({
  type: actions.RETRIEVE_DOWNLOAD_RULES_REQUEST,
  requestPromise,
});

export const retrieveDownloadRulesSuccess = downloadRules => ({
  type: actions.RETRIEVE_DOWNLOAD_RULES_SUCCESS,
  downloadRules,
});

export const retrieveDownloadRulesFailure = err => ({
  type: actions.RETRIEVE_DOWNLOAD_RULES_FAILURE,
  err,
});

export const retrieveDownloadRules = () =>
  function retrieveDownloadRulesDispatch(dispatch) {
    const params = {
      option: 'DOWNLOAD_RULES',
      SEARCH: 'EXTERNAL*',
    };
    const promise = piction.request('AUTOSUGGEST', params)
      .then((res) => {
        if ((res.message && res.message.includes(SESSION_EXPIRED_MESSAGE)) ||
          (res.RETURN_MESSAGE && res.RETURN_MESSAGE.includes(SESSION_EXPIRED_MESSAGE))) {
          dispatch(sessionExpired(res));
        } else if (res.a && res.a.rs) {
          dispatch(retrieveDownloadRulesSuccess(res.a.rs));
          return res.a.rs;
        } else {
          dispatch(retrieveDownloadRulesFailure(res));
          return ([]);
        }
        return res;
      })
      .catch((err) => {
        if ((err.message && err.message.includes(SESSION_EXPIRED_MESSAGE)) ||
          (err.RETURN_MESSAGE && err.RETURN_MESSAGE.includes(SESSION_EXPIRED_MESSAGE))) {
          dispatch(sessionExpired(err));
        } else {
          dispatch(retrieveDownloadRulesFailure(err));
        }
        return err;
      });

    dispatch(retrieveDownloadRulesRequest(promise));
    return promise;
  };
